import { Component, OnInit, inject } from '@angular/core';

import { DynamicHtmlDirective } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';

import { MessageType } from '../../../../model/message.model';
import { ResizeService } from '../../../../service/resize.service';
import { UserDataService } from '../../../../service/userDataService';
import { MessageComponent } from '../../../../shared/components/messages/message-component';

@Component({
    selector: 'app-session-limits',
    templateUrl: './session-limits.component.html',
    imports: [MessageComponent, TranslateModule, DynamicHtmlDirective],
})
export class SessionLimitsComponent implements OnInit {
    private userDataService = inject(UserDataService);
    private resizeService = inject(ResizeService);

    isSessionTimeoutStatus: any;
    sessionTimeUpdateUrl: string;

    public get messageType(): typeof MessageType {
        return MessageType;
    }

    ngOnInit() {
        this.isSessionTimeoutStatus = this.userDataService?.userData?.userInfo?.sessionTimeOutStatus;

        if (this.isSessionTimeoutStatus) {
            this.sessionTimeUpdateUrl = this.userDataService?.userData?.configParams?.session_limit_update_url;
        }
        this.resizeService.resizeCashier();
    }
}
